import { parseDomain, ParseResultType, fromUrl } from 'parse-domain';

export function okayActor (url: string) {
  const domain = fromUrl(url);
  // no whitespace, no comma-separated or semicolon-separated URLs
  return !url.match(/\s/) && !url.match(/[,;]https?:\/\//) && typeof(domain) === 'string' && domain !== url && okayDomain(domain);
};

export function okayDomain (domain: string, icann: Boolean=true) {
    const parsed = parseDomain(domain);
    if (parsed.type !== ParseResultType.Listed)
        return;
    return icann ? [parsed.icann.domain, ...parsed.icann.topLevelDomains].join('.') : [parsed.domain, ...parsed.topLevelDomains].join('.');
};

export function isDomain (domain: string, icann: Boolean=true) {
    const parsed = parseDomain(domain);
    if (parsed.type !== ParseResultType.Listed)
        return;
    return domain === (icann ? [parsed.icann.domain, ...parsed.icann.topLevelDomains].join('.') : [parsed.domain, ...parsed.topLevelDomains].join('.'));
};
